<template>
  <div class="artist-container">
    <div class="splash" v-if="!value || !value.results.length">
      <div class="artworks"></div>

      <div v-if="!value">
        <font-awesome-icon slot="spinner" icon="spinner" size="2x" pulse />
      </div>
      <div v-else-if="!value.results.length">
        결과가 없습니다.
      </div>
    </div>

    <template v-else>
      <div>
        <article
          :key="artist.slug"
          class="card"
          v-for="artist in value.results"
        >
          <router-link :to="`/${artist.slug}/`">
            <div class="background"></div>
            <figure>
              <img
                :src="artist.cropped_avatar"
                class="w-100 rounded-circle"
                v-if="artist.cropped_avatar"
              />
              <img src="../assets/avatar.png" class="w-100" v-else />
              <p class="levels" v-if="user.is_staff">
                <b-button
                  :key="level"
                  class="mr-1"
                  :disabled="artist.level === level"
                  size="sm"
                  @click.prevent="setLevel(artist, level)"
                  v-for="level in [5, 4, 3, 2, 1, 0]"
                >
                  {{ level }}
                </b-button>
              </p>
            </figure>
            <footer>
              <address>
                {{ artist.name }}
              </address>
            </footer>
          </router-link>
        </article>
      </div>
      <infinite-loading
        :identifier="identifier"
        @infinite="infinite"
        ref="infiniteLoading"
      >
        <div slot="spinner" class="p-5">
          <font-awesome-icon slot="spinner" icon="spinner" size="2x" pulse />
        </div>
        <span slot="no-more" />
        <span slot="no-results" />
      </infinite-loading>
    </template>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { User } from "../models";
import axios from "axios";

export default {
  name: "artists",
  components: {
    InfiniteLoading
  },
  props: ["value"],
  data() {
    return {
      user: new User(window.user),
      identifier: new Date()
    };
  },
  watch: {
    "value._isNoMore"(isNoMore) {
      if (isNoMore) {
        return;
      }

      this.identifier = new Date();
    }
  },
  methods: {
    async infinite($state) {
      const { _currentPage } = this.value;
      if (!this.value.loadMore) {
        $state.complete();
        return;
      }

      const artists = await this.value.loadMore();
      if (artists._currentPage === _currentPage) {
        $state.complete();
      } else {
        this.$emit("input", artists);
        $state.loaded();
      }
    },
    async setLevel(artist, level) {
      artist.level = level;

      await axios.patch(`/api/v1/users/${artist.id}/`, {
        level
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.artist-container {
  margin: 0 auto;
  max-width: 100% !important;

  @media (min-width: 580px) {
    max-width: 580px !important;
  }

  @media (min-width: 870px) {
    max-width: 870px !important;
  }

  @media (min-width: 1160px) {
    max-width: 1160px !important;
  }

  @media (min-width: 1450px) {
    max-width: 1450px !important;
  }
}

.card {
  overflow: hidden;
  display: inline-block;
  width: calc(50vw - 48px);
  margin: 0 24px 12px;

  @media (min-width: 548px) {
    width: 240px;
    margin: 0 25px 60px;
  }

  .background {
    position: absolute;
    width: 100%;
    height: calc(100% - 35px);

    &:hover {
      background-color: white;
      opacity: 0.3;
    }
  }

  footer {
    margin-bottom: 0;

    address {
      font-size: 13px;
      font-weight: bold;
      text-transform: uppercase;
      text-align: center;
      color: #484848;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.splash {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: rgba(0, 0, 0, 0.5);
}

.levels {
  position: absolute;
  right: 0;
  margin-top: -20px;
}
</style>
